// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-header{background:#000!important;border-color:#000!important;font-size:16px;color:#fff}.el-table__body-wrapper{z-index:2}.el-table__fixed,.el-table__fixed-right{box-shadow:none}.el-table .cell{font-size:18px;white-space:pre-line;overflow:unset}.btns{display:flex;gap:4px}", ""]);
// Exports
module.exports = exports;
